import React, { useEffect, useState } from 'react'
import { Form, Input } from 'antd-mobile-v5'
import { useIntl } from 'react-intl'
import { useGetStandardRegions } from '../../services/hooks'
import { useLanguage } from '../../services/hooks/user'
import areaDataSc from '../../assets/pca-code-m2.json'
import areaDataTc from '../../assets/pca-code-m2-tc.json'
import areaDataEn from '../../assets/pca-code-m2-en.json'
import PickerTool from './Picker'

const AddressForm = ({ form, editable }) => {
  const { formatMessage } = useIntl()
  const lang = useLanguage()
  const [regionData, setRegionData] = useState([])
  const [regionId, setRegionId] = useState()
  const regionIdValue = Form.useWatch('addressRegionId', form)
  const { loading } = useGetStandardRegions({
    onSuccess: (data) => {
      const formatData = data.map((item) => {
        return {
          label: item.region,
          value: item.id,
        }
      })
      setRegionData(formatData)
    },
  })

  const matchLangArea = () => {
    switch (lang) {
      case 'sc':
        return areaDataSc
      case 'tc':
        return areaDataTc
      case 'en':
        return areaDataEn
    }
  }

  useEffect(() => {
    if (regionIdValue) {
      setRegionId(parseInt(regionIdValue))
    }
  }, [regionIdValue])

  const validateField = (_, value) => {
    if (value === -1 || !value) return Promise.reject(new Error('省市不能为空'))
    else return Promise.resolve()
  }

  return (
    <>
      <PickerTool
        name={'addressRegionId'}
        form={form}
        rules={[
          {
            required: true,
            message: '地区不能为空',
          },
        ]}
        placeholder={formatMessage({ id: 'dm-select-region-error' })}
        data={regionData}
        label={formatMessage({ id: 'setMobile-regions' })}
        disabled={!editable}
      />
      {regionId === 51 && (
        <PickerTool
          name={'addressStateId'}
          form={form}
          rules={[
            {
              required: true,
              message: '省市不能为空',
            },
            {
              validator: validateField,
            },
          ]}
          placeholder={formatMessage({ id: 'common-select' })}
          data={matchLangArea()}
          label={formatMessage({ id: 'common-Province' })}
          disabled={!editable}
        />
      )}
      <Form.Item
        form={form}
        name="address"
        label={formatMessage({ id: 'common-address' })}
        rules={[
          {
            required: true,
            message: formatMessage({ id: 'common-address-reminder' }),
          },
        ]}
      >
        <Input />
      </Form.Item>
    </>
  )
}

export default AddressForm
